import Vue from "vue";
import "mint-ui/lib/toast/style.css";
import "mint-ui/lib/indicator/style.css";
import "mint-ui/lib/toast/style.css";
import { Toast, Indicator, MessageBox } from "mint-ui";
import { type, guid } from "./util/util";
import jumpMgr from "./task/jumpMgr";
import taskMgr from "./task/taskMgr";
import urlHelper from "./util/urlHelper";
import storage from "./util/CacheStorage.js";
import SupremePlugin from "./reuse/plugins/SupremePlugin";
import { getQueryString, getQueryObject } from "./util/util";
import _ from "lodash";

var rbracket = /\[\]$/,
  rCRLF = /\r?\n/g,
  rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
  rsubmittable = /^(?:input|select|textarea|keygen)/i;
function buildParams(prefix, obj, traditional, add) {
  var name;

  if (Array.isArray(obj)) {
    // Serialize array item.

    for (let [i, v] of obj.entries()) {
      if (traditional || rbracket.test(prefix)) {
        // Treat each array item as a scalar.
        add(prefix, v);
      } else {
        // Item is non-scalar (array or object), encode its numeric index.
        buildParams(
          prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]",
          v,
          traditional,
          add
        );
      }
    }
  } else if (!traditional && _.isObject(obj)) {
    // Serialize object item.
    for (name in obj) {
      buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
    }
  } else {
    // Serialize scalar item.
    add(prefix, obj);
  }
}
/**
 *@exports supreme
 *@desc 封装superme 主要的公用方法,并对vue进行基础扩展,加载全局组件等等
 *@author lei.you
 *@date 2018/02/08
 *@update  2018/12/22
 *@description 修改mint 按需引入
 * */
var supreme = {
  /**
   * @property {boolean} inPad
   * */

  /**
   * @property {boolean} $
   * */
  productionTip: false,
  /**
   * @property {vue} 公用事件总线
   * */
  //公用总线
  pubHubus: new Vue(),
  /**
   * @property {storage}  一个封装过的storage 解决存储时间和序列号的问题
   * */
  cache: storage,
  /**
   * @property {storage} localstorage
   * */
  localCache: storage.getInstance({ storage: "localStorage" }),
  /**
   * @property {storage} sessionstorage
   * */
  sessionCache: storage.getInstance({ storage: "sessionStorage" }),
  /**
   * @property {mint-ui} toast
   * */
  toast: Toast,
  /**
   * @property {router} app程序的router
   * */
  $router: null,
  /**
   * @property {mint-ui} indicator
   * */
  enableErrorLog: true,
  indicator: Indicator,
  init(config) {
    _.extend(this, config);
    if (urlHelper.get("origin")) {
      this.sessionCache.set("origin", urlHelper.get("origin"));
    }
    jumpMgr.init(config);
  },

  /**
   * @param {string} param key 参数名
   * @return 获取url上的参数
   * */
  getQueryString(key) {
    return getQueryString(key);
  },
  /**
   *
   * @return 获取url上的参数对象
   * */
  getQueryObject() {
    return getQueryObject();
  },
  getOrigin() {},
  /**
   * @return long 时间戳
   * */
  getTimestamp() {
    return Date.parse(new Date());
  },
  /**
   * @param {string||object} msg
   * @desc 提供一个最常用的toast 其他功能的toast 请直接使用 this.toast
   * */

  showToast(msg) {
    if (type.isObject(msg)) {
      this.toast(JSON.stringify(msg));
    }
    this.toast(msg);
  },
  /**
   * @param {string||object}  msg
   * @desc 提供一个最简单最常用的loading 用法
   * */
  //
  showLoading(msg) {
    if (type.isString(msg)) {
      this.indicator.open(msg);
    }
    if (type.isObject(msg)) {
      this.indicator.open(msg);
    }
    return this;
  },
  /**
   * @desc 隐藏loading效果
   * */
  hideLoading() {
    this.indicator.close();
    return this;
  },
  /**
   * @description alert
   * @param message
   * @param title
   * @param callback
   * */
  alert(message, title, callback) {
    if (_.isObject(message)) {
      message = JSON.stringify(message);
    }
    if (_.isFunction(title)) {
      callback = title;
    }

    MessageBox.alert(message, title).then(e => {
      if (_.isFunction(callback)) {
        callback;
      }
    });
  },
  /**
   * @description alert
   * @param message
   * @param title
   * @param callback
   * */

  confirm(message, title, callback) {
    if (_.isObject(message)) {
      message = JSON.stringify(message);
    }
    if (_.isFunction(title)) {
      callback = title;
    }

    MessageBox.confirm(message, title).then(e => {
      if (_.isFunction(callback)) {
        callback;
      }
    });
  },
  prompt() {},
  /**
   * @description 参数序列化
   * @param a object
   * @param traditional 默认不填写
   *
   * */
  param(a, traditional) {
    var prefix,
      s = [],
      add = function(key, valueOrFunction) {
        // If value is a function, invoke it and use its return value
        var value = _.isFunction(valueOrFunction)
          ? valueOrFunction()
          : valueOrFunction;

        s[s.length] =
          encodeURIComponent(key) +
          "=" +
          encodeURIComponent(value == null ? "" : value);
      };

    // If traditional, encode the "old" way (the way 1.3.2 or older
    // did it), otherwise encode params recursively.
    for (prefix in a) {
      buildParams(prefix, a[prefix], traditional, add);
    }

    // Return the resulting serialization
    return s.join("&");
  },
  /**
   * @desc 辅助跳转，跳转不会记录到taskStack 中
   * @param {string}  pathName 跳转的路由名称
   * @param {object}  params 跳转携带的参数
   * @return {supreme} 返回supreme 本身
   *
   * */
  forward(pathName, params) {
    jumpMgr.forward(pathName, params);
    return this;
  },
  /**
   * @desc 替换当前栈顶页面
   * @param {string}  pathName 跳转的路由名称
   * @param {object}  params 跳转携带的参数
   * @return {supreme} 返回supreme 本身
   *
   * */
  replace(pathName, params) {
    jumpMgr.replace(pathName, params);
    return this;
  },
  /**
   * @desc 跳转功能，跳转会记录到taskStack中
   * @param {string}  跳转的路由名称
   * @param {object}  跳转携带的参数
   * @return {supreme} supreme 返回supreme 本身
   *
   * */
  goto(pathName, params) {
    if (!this.$router) {
      this.showToast("请先初始化supreme 的$router 后使用改方法");
    }
    jumpMgr.goto(pathName, params);
    return this;
  },
  /**
   * @desc 最常用回退功能
   * @param {object}  回退携带的参数
   * @return {supreme} 返回supreme 本身
   *
   * */
  back(params) {
    if (!this.$router) {
      this.showToast("请先初始化supreme 的$router 后使用改方法");
    }
    jumpMgr.back(params);
    return this;
  },
  /**
   * @desc 页面强行加载，不再使用单页模式
   * @param {object}  回退携带的参数
   * @return {supreme} 返回supreme 本身
   *
   * */
  jump(url) {
    if (!this.$router) {
      this.showToast("请先初始化supreme 的$router 后使用改方法");
    }
    jumpMgr.jump(url);
    return this;
  },
  /**
   * @desc 回退到指定页面，按照步数回退
   * @param {object}  model ={
   *            step, 指定回退 步数  正整数
   *            name, 指定回退到最近的指定名字的task
   *            step name 不能同时指定，如果同时指定会优先step
   *            clearCache true false 是否清缓存
   *          }
   * @parmas {object}  回退携带的参数
   * @return {supreme} 返回supreme 本身
   *
   * */
  backToPage(model, params) {
    if (!this.$router) {
      this.showToast("请先初始化supreme 的$router 后使用改方法");
    }
    jumpMgr.backToPage(model, params);
    return this;
  },
  /**
   *
   * @desc 清除taskStack 和 本地缓存的中浏览历史 ，慎用
   *
   * */
  //辅助清除历史
  clearHistory() {
    taskMgr.clear();
    return this;
  }
};

try {
  var testKey = guid.getGuid();
  localStorage.setItem(testKey, testKey);
  localStorage.removeItem(testKey);
} catch (e) {
  console.error("supreme error: ", e);
}
// 扩展相关功能
Vue.use(SupremePlugin);
export default supreme;
